import {
  namePatternMatch,
  emailPatternMatch,
} from "../../../utilities/helpers";

import { isValidPhoneNumber } from "react-phone-number-input";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";

import { PhoneNumberInput } from "../../../components/PhoneNumberInput";
import { Error } from "../../../components/Error";

export default function AssignToV2({
  assignTo,
  onAssignToChange,
  isValidEmail,
  setIsValidEmail,
  isValidNumber,
  setIsValidNumber,
}) {
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "email" || value === "" || e.target.validity.valid) {
      onAssignToChange(name, value);
    }
  };

  const handleValidEmail = (e) => {
    if (!emailPatternMatch(e.target.value)) {
      setIsValidEmail(false);
    } else {
      setIsValidEmail(true);
    }
  };

  const handleValidNumber = () => {
    // Since not required -> empty is valid
    if (!assignTo.phoneNumber) {
      setIsValidNumber(true);
      return;
    }

    setIsValidNumber(isValidPhoneNumber(assignTo.phoneNumber));
  };

  return (
    <Stack gap={4}>
      <Form.Group className="form-group" controlId="orgName">
        <Form.Label>Organization name (optional)</Form.Label>
        <Form.Control
          type="text"
          name="organizationName"
          placeholder="Enter your organization name"
          value={assignTo?.organizationName || ""}
          onChange={handleChange}
          autoComplete="none"
        />
      </Form.Group>
      <Row className="m-0">
        <Col className="ps-0">
          <Form.Group className="form-group" controlId="firstName">
            <Form.Label>First name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              pattern={namePatternMatch}
              placeholder="Enter your first name"
              value={assignTo?.firstName || ""}
              onChange={handleChange}
              required
              autoComplete="none"
            />
          </Form.Group>
        </Col>
        <Col className="pe-0">
          <Form.Group className="form-group" controlId="lastName">
            <Form.Label>Last name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              pattern={namePatternMatch}
              placeholder="Enter your last name"
              value={assignTo?.lastName || ""}
              onChange={handleChange}
              required
              autoComplete="none"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="ps-0">
          <Form.Group className="form-group" controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={assignTo?.email || ""}
              onChange={handleChange}
              onBlur={handleValidEmail}
              required
              autoComplete="none"
              className={`${!isValidEmail ? "error-border" : ""}`}
            />

            {!isValidEmail && <Error type="invalidEmail" />}
          </Form.Group>
        </Col>
        <Col className="pe-0">
          <Form.Group className="form-group" controlId="lastName">
            <Form.Label>Phone number</Form.Label>
            <PhoneNumberInput
              phoneNumber={assignTo?.phoneNumber}
              setPhoneNumber={(value) => onAssignToChange("phoneNumber", value)}
              isRequired={false}
              onBlur={handleValidNumber}
              hasError={!isValidNumber}
            />
          </Form.Group>
        </Col>
      </Row>
    </Stack>
  );
}
